module.exports = require("react-loading-skeleton");